import type { CardHooks } from "./registry";

/**
 * Iron Break Sigil — Reaction utility, costs 1 stamina.
 * Effect: negate the opposing attack.
 *
 * Implementation: pure-data marker. The card carries the "Negate" keyword
 * (capital N) in its keywords array, so playUtility's `isNegateCard` check
 * at line ~4031 in playtestEngine.ts routes it to a deferred "negate" stack
 * entry, which `resolveStackEntry` pops to negate the most-recent stack
 * entry below it (mirroring Saw it Coming for attack-play entries).
 *
 * To be played, the card needs:
 *   • utilityType: "Reaction"
 *   • reactionTriggers: ["opponent-plays-attack"]
 *   • staminaCost: "1"
 *   • keywords: ["Negate"]
 *
 * Those live in the Supabase row, NOT here.
 */
export const ironBreakSigil: CardHooks = {
  onUtilityPlay: (_ctx) => {
    // The actual negation runs through the deferred "negate" stack entry,
    // not via this hook. Log only.
    return { log: ["Iron Break Sigil — negating opposing attack."] };
  },
};
